import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { DatePipe } from '@angular/common';
import { I18nModule } from '@spartacus/core';
import { NoItemsDisclaimerComponent } from '../no-items-disclaimer/no-items-disclaimer.component';
import { MakeAPaymentService } from '../make-a-payment.service';
import { PaymentConfirmation } from '../../shared/models/make-payment.model';

@Component({
  selector: 'sanofi-payments-confirmation-credits-list',
  standalone: true,
  imports: [
    I18nModule,
    NoItemsDisclaimerComponent,
    DatePipe
  ],
  templateUrl: './payments-confirmation-credits-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PaymentsConfirmationCreditsListComponent {
  private readonly makeAPayment = inject(MakeAPaymentService);

  paymentResponse = input.required<PaymentConfirmation>();
  currentDate = input.required<Date>();
  userId = input.required<string>();

  invoicePdf(credNum: string): void {
    this.makeAPayment.downloadPdf(credNum);
  }
}
